import { SectionProps } from "./SectionProps";
import { CommissionModel } from "../../domain/CommissionModel";
import { Select } from "@ofqual/portal-components/components/Select";
import { Controller } from "react-hook-form";
import { Grid } from "@material-ui/core";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { assignableManagersService } from "../../services";

export const AssignedComissionsManager: React.FC<{ sectionProps: SectionProps<CommissionModel>; }> = ({ sectionProps }) => {
    const { control, editable, lookupTracker } = sectionProps;
    const readOnly: boolean | undefined = editable ? false : true;
    
    const [managerLookups] = useLookup(assignableManagersService);  
   
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Controller control={control} name="assignedManagers" rules={{ required: false }} as={ 
                   <Select
                     selectVariant="multiple"
                     label="Assigned Managers" 
                     data-test="assigned-commissions-managers"
                     readOnly={ readOnly } 
                     
                     lookupTracker={ lookupTracker }
                   >
                     { managerLookups }
                   </Select>                
                }              
                />               
            </Grid>
        </Grid>
    );
};